package com.parmartechnologies.commerce.feature.inventory.viewModel.product_color

import com.parmartechnologies.core.feature.inventory.color.model.ProductColor
import com.parmartechnologies.core.feature.inventory.color.network.CreateColorRequest
import com.parmartechnologies.core.feature.inventory.color.network.RetrieveProductColorRequest
import com.parmartechnologies.core.feature.inventory.color.network.UpdateColorRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.inventory.handler.ProductColorHandler
import com.parmartechnologies.commerce.feature.inventory.network.product_color.ProductColorNetwork
import com.parmartechnologies.commerce.feature.inventory.repository.ProductColorRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.table.inventory.product_color.ProductColorDatabaseTable
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class ProductColorViewModel(val business: Business, val repository: ProductColorRepository = ProductColorHandler.shared().repository) :
    AppViewModel() {

    val allProductColor: StateFlow<List<ProductColor>>
        get() = repository.productColorLiveData

    val selectedProductColor: StateFlow<ProductColor?>
        get() = repository.selectedProductColor

    fun fetchAllColor() {
        loadFromStorage()
        if (allProductColor.value.isEmpty()) {
            val request =
                RetrieveProductColorRequest(business._id)
            scope.launch {
                ProductColorNetwork().retrieve(request) {
                    stopLoading()
                    ProductColorDatabaseTable().insert(it?.payload)
                    loadFromStorage()
                }
            }
        }
    }

    fun loadAllColor() {
        fetchAllColor()
    }

    private fun loadFromStorage() {
        ProductColorDatabaseTable().retrieve(business._id) { data ->
            scope.launch {
                repository.productColorLiveData.emit(data)
            }
        }
    }

    fun getColorById(id: String?, callback: (ProductColor?) -> Unit) {
        ProductColorDatabaseTable().find(id ?: "") { data ->
            scope.launch {
                callback(data)
            }
        }
    }

    fun createNewColor(name: String, code: String, hex: String, description: String, completion: () -> Unit) {
        val request = CreateColorRequest(
            name,
            code,
            hex,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            ProductColorNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allColor: MutableList<ProductColor> =
                            repository.allProductColor.value.toMutableList()
                        allColor.add(it.payload!!)
                        repository.productColorLiveData.emit(allColor)
                        ProductColorDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }

    fun updateColor(name: String, id: String, code: String, hex: String, description: String, completion: () -> Unit) {
        val request = UpdateColorRequest(
            name,
            id,
            code,
            hex,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            ProductColorNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allColor: MutableList<ProductColor> =
                            repository.allProductColor.value.toMutableList()
                        allColor.add(it.payload!!)
                        repository.productColorLiveData.emit(allColor)
                        ProductColorDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }
}